import { Form, Input, message, Button, Select } from "antd";
import { formLayout } from "../../../utils/constants";
import { addOne } from "../../../api/bdPosibleParticipante";
import { useHistory } from "react-router-dom";

const { Option } = Select;

export default function AddBDPosibleParticipante({ closeModal }) {
  const history = useHistory();

  const onFinish = (values) => {
    sendDataToServer(values);
  };

  const sendDataToServer = async (data) => {
    try {
      const response = await addOne(data);
      message.success(response.message);
      history.replace("/app/bdparticipante");
      closeModal();
    } catch (err) {
      message.error(err.message);
    }
  };

  const onFinishFailed = ({ values }) => {
    if (Number(values.nrodocumento) < 1) {
      message.error("Número de DNI no válido");
    }
  };

  return (
    <Form
      {...formLayout.formItemLayout}
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Form.Item
        label="Número de DNI"
        name="nrodocumento"
        rules={[
          {
            required: true,
            message: "El DNI es necesario"
          },
          {
            len: 8,
            message: "El valor debe tener 8 caracteres"
          }
        ]}
      >
        <Input type="number" />
      </Form.Item>

      <Form.Item
        label="Nombres"
        name="nombre"
        rules={[{ required: true, message: "El nombre es necesario" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Apellidos"
        name="apellido"
        rules={[{ required: true, message: "El apellido es necesario" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Correo electrónico"
        name="email"
        rules={[{ required: true, message: "El email es necesario" }]}
      >
        <Input type="email" />
      </Form.Item>

      <Form.Item label="Celular" name="nrocelular">
        <Input />
      </Form.Item>

      <Form.Item
        label="Elige el tipo"
        name="tipoorigen"
        rules={[{ required: true, message: "El origen es necesario" }]}
      >
        <Select placeholder="Elige el tipo">
          <Option value="estudiante">ESTUDIANTE</Option>
          <Option value="docente">DOCENTE</Option>
          <Option value="administrativo">ADMINISTRATIVO</Option>
        </Select>
      </Form.Item>

      <div className="flex justify-end gap-4">
        <Form.Item {...formLayout.tailFormItemLayout}>
          <Button type="primary" block htmlType="submit">
            Registrar
          </Button>
        </Form.Item>
        <Button type="default" onClick={() => closeModal()}>
          Cancelar
        </Button>
      </div>
    </Form>
  );
}
